import React from 'react';
import { Box, Avatar, useTheme } from '@mui/material';
import newLogo from '../../../../assets/icons/new_logo.svg';

const Thinking = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: '1rem',
      }}
    >
      <Avatar
        sx={{
          marginRight: '0.5rem',
          bgcolor: 'transparent',
          '& img': {
            height: '100%',
            width: '100%',
            maxHeight: 30,
            maxWidth: 120,
            objectFit: 'contain',
          },
        }}
        src={newLogo}
        alt="ScreenApp"
        variant="square"
      />
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
          borderRadius: '12px',
          borderTopLeftRadius: '4px',
          padding: theme.spacing(1.5, 2),
          position: 'relative',
          maxWidth: '70%',
          minWidth: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
        }}
      >
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            component="span"
            sx={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: theme.palette.action.active,
              opacity: 0.7,
              animation: 'fadeInOut 1.5s infinite',
              animationDelay: `${index * 0.2}s`,
              '@keyframes fadeInOut': {
                '0%, 100%': { opacity: 0.3 },
                '50%': { opacity: 0.7 },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Thinking;
